import * as actionTypes from 'constants/ActionTypes';

const initState = {
        loading: false,
        page: 1,
        next: 2,
        previous: 1,
        limit: 50,
        // sortField: 'addedAt',
        // sortValue: -1,
        filters: {
            search: '',
        },
    data: [],
};

const issues = (state = initState, action) => {
    switch (action.type) {
        case actionTypes.GET_ISSUES.REQUEST:
            return {
                ...state,
                ...action.pagination,
                loading: true,
            };
        case actionTypes.GET_ISSUES.SUCCESS: {
            return {
                ...state,
                ...action.data,
                loading: false,
            };
        }
        case actionTypes.GET_ISSUES.FAILURE:
            return {
                ...state,
                ...action.data,
                loading: false,
            };
        default:
            return state;
    }
};

export default issues;



// WEBPACK FOOTER //
// ./app/reducers/issues/issues.js